<template>
  <Card :padding="0" class="card-item" style="width: 450px">
    <div class="close" @click="closeCard">
      <Icon type="ios-close" size="28" />
    </div>
    <div class="contetn">
      <Select
        @on-change="selectSemiItem"
        v-model="semiItemId"
        clearable
        filterable
        style="width: 200px; margin: 28px 0 20px 0"
      >
        <Option v-for="item in semiItemList" :value="item._id" :key="item._id"
          >{{ item.material.model }}-{{ item.factory.name }}</Option
        >
      </Select>
      <div class="solidContent-wrap" v-if="semiItem.solidContent">
        <div class="solidContent-item">
          <div>固含量：</div>
          <div>{{ semiItem.solidContent }}</div>
        </div>
        <div class="solidContent-item">
          <div>固含价格：</div>
          <div>{{ semiItem.unitCostPerSoidContent.toFixed(3) }}</div>
        </div>
      </div>
      <div class="material-table">
        <Table
          border
          :loading="materialTableLoading"
          :columns="materialTableColumns"
          :data="materialCostDetail"
        >
        </Table>
      </div>
    </div>
  </Card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "SemiContrastCard",
  props: ["index", "materialPurchaseList"],
  data() {
    return {
      semiItemId: "",
      materialTableLoading: false,
      semiItem: {},
      materialCostDetail: [],
      materialTableColumns: [
        {
          title: "材料",
          key: "material",
          align: "left",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  fontSize: 16,
                },
              },
              params.row.material.model
                ? params.row.material.model
                : params.row.material.name
            );
          },
        },
        {
          title: "比例",
          key: "ratio",
          align: "right",
          width: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.ratio ? (params.row.ratio * 100).toFixed(2) + "%" : ""
            );
          },
        },
        {
          title: "单价",
          key: "materialCost",
          align: "right",
          width: 100,
          render: (h, params) => {
            if (!params.row.material) return null;
            if (params.row.material.name === "水") return 0;
            const unitCost = this.materialPurchaseList.find(
              (x) => x.material._id === params.row.material._id
            );
            if (unitCost === undefined) {
              return "-";
            }
            return h("div", parseInt(unitCost.calcPurchaseUnitCost));
          },
        },
        {
          title: "价格",
          key: "materialCost",
          width: 100,
          align: "right",
          render: (h, params) => {
            if (params.row.material.model === "材料合计")
              return h("div", parseInt(params.row.materialCost));
            const unitCost = this.materialPurchaseList.find(
              (x) => x.material._id === params.row.material._id
            );
            if (unitCost === undefined) return "-";
            return h(
              "div",
              parseInt(params.row.ratio * unitCost.calcPurchaseUnitCost)
            );
          },
        },
      ],
      preDate: {},
    };
  },
  computed: {
    ...mapState({
      semiItemList: (state) => state.semiItem.semiItemList,
    }),
    reCalcMaterialCostDetail: function () {
      if (!this.semiItem || !this.semiItem.materialCostDetail) return [];
      let cost = this.semiItem.materialCostDetail;
      cost.forEach((e) => {
        if (!e.material) return {};
        if (e.material.name === "水") {
          return { ...e, calcPurchaseUnitCost: 0, materialCost: 0 };
        }
        const unitCost = this.materialPurchaseList.find(
          (x) => x.material._id === e.material._id
        );
        if (unitCost === undefined) {
          return { ...e, calcPurchaseUnitCost: 0, materialCost: 0 };
        }
        const a = {
          ...e,
          calcPurchaseUnitCost: unitCost.calcPurchaseUnitCost,
          materialCost: unitCost.calcPurchaseUnitCost * e.ratio,
        };
        return a;
      });
      return cost;
    },
  },
  watch: {
    materialPurchaseList: {
      handler(newValue, old) {
        if (!this.materialCostDetail) return;

        this.materialCostDetail.forEach((e) => {
          if (e.material.model === "材料合计") {
            e.materialCost = 0;
            for (let i = 0; i < this.materialCostDetail.length - 1; i++) {
              e.materialCost += this.materialCostDetail[i].materialCost;
            }
            return;
          }
          if (e.material.name === "水") {
            e.calcPurchaseUnitCost = 0;
            e.materialCost = 0;
            return;
          }
          const unitCost = this.materialPurchaseList.find(
            (x) => x.material._id === e.material._id
          );
          if (unitCost === undefined) {
            e.calcPurchaseUnitCost = 0;
            e.materialCost = 0;
            return;
          }

          e.calcPurchaseUnitCost = Number(unitCost.calcPurchaseUnitCost);
          e.materialCost = unitCost.calcPurchaseUnitCost * e.ratio;
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      getSemiItem: "semiItem/getSemiItemAction",
      getSemiLatestCostDetail: "calcSemiCost/getSemiLatestCostDetailAction",
    }),
    async selectSemiItem() {
      if (this.semiItemId) {
        try {
          this.materialTableLoading = true;
          let originMaterialList = [];
          if (this.semiItem.materialCostDetail) {
            originMaterialList = this.semiItem.materialCostDetail
              .slice(0, this.semiItem.materialCostDetail.length - 1)
              .filter((x) => x.material.name !== "水")
              .map((x) => {
                return {
                  material: x.material,
                  calcPurchaseUnitCost: x.calcPurchaseUnitCost,
                };
              });
          }
          let semiItem = await this.getSemiLatestCostDetail(this.semiItemId);
          const newMaterialList = semiItem.calcSemiCost.materialCostDetail
            .filter((x) => x.material.name !== "水")
            .map((x) => {
              return {
                material: x.material,
                calcPurchaseUnitCost: x.calcPurchaseUnitCost,
              };
            });
          this.$emit("changeSemi", originMaterialList, newMaterialList);

          const data = semiItem.calcSemiCost;
          const total = { material: {}, materialCost: null };
          total.material.model = "材料合计";
          total.materialCost = data.materialCost;
          total.ratio = data.materialCostDetail.reduce((p, c) => {
            return p + c.ratio;
          }, 0);
          data.materialCostDetail.push(total);
          this.materialCostDetail = data.materialCostDetail;
          this.semiItem = data;
          this.materialTableLoading = false;
        } catch (error) {
          return this.$Message.error(error + "获取母液详情错误");
        }
      }
    },
    closeCard() {
      this.$emit("closeCard", this.index);
    },
  },
};
</script>
<style lang="stylus" scoped>
.close
  position absolute
  right 0
  cursor pointer

.contetn
  padding 0 20px 20px 20px

.solidContent-item
  display flex
</style>